import {
  computePosition, flip,
  shift,
  offset,
  arrow
} from '@floating-ui/dom';
const listOfInfoElements = [
  'content-rotoclear-answer__info', 'content-rotoclear-product__info', 'content-rotoclear-question-group__info', 'rotoclear-configurator__accessory__info'];
document.addEventListener('DOMContentLoaded', () => {
  // Ensure the DOM is fully loaded before running the script

  const singleConfiguratorModule = document.querySelector('.module-rotoclear-single-configurator');
  document.addEventListener('click', (event) => {
    const openModal = document.querySelector('.rotoclear-modal--open');
    if (openModal && !openModal.contains(event.target)) {
      openModal.classList.remove('rotoclear-modal--open');
    }
  }, true);
  console.log('found target element:', singleConfiguratorModule);
  if (singleConfiguratorModule) {
    const observer = new MutationObserver((mutationsList) => {
      console.log('MutationObserver triggered:', mutationsList);
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (
              node.nodeType === Node.ELEMENT_NODE &&
              listOfInfoElements.some(cls => node.classList.contains(cls))
            ) {
              bindEventListenerForModals(node);
            }
            // Add event listener for out of modal close
            if (node.nodeType === Node.ELEMENT_NODE &&
              node.classList.contains('rotoclear-modal')
            ) {
              node.addEventListener('mouseenter', (event) => {
                event.stopPropagation();
                event.preventDefault();
                const infoEvent = new MouseEvent('mouseenter', {
                  bubbles: true,
                  relatedTarget: event.currentTarget.parentElement.parentElement.querySelector(listOfInfoElements.map(cls => `.${cls}`).join(', '))
                });
                showEvent(infoEvent);
              });
              node.addEventListener('mouseleave', (event) => {
                handleMouseLeave(event);
              });
            }
            if (
              node.nodeType === Node.ELEMENT_NODE &&
              node.classList.contains("rotoclear-modal__close")
            ) {
              bindCloseEventListenerForModals(node);
            }
            // Also check descendants in case of subtree additions
            if (node.nodeType === Node.ELEMENT_NODE) {
              listOfInfoElements.forEach(cls => {
                node.querySelectorAll(`.${cls}`).forEach(el => {
                  bindEventListenerForModals(el);
                });
                node.querySelectorAll('.rotoclear-modal').forEach(modal => {
                  modal.addEventListener('mouseleave', (event) => {
                    handleMouseLeave(event);
                  });
                  modal.addEventListener('mouseenter', (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    const infoEvent = new MouseEvent('mouseenter', {
                      bubbles: true,
                      relatedTarget: event.currentTarget.parentElement.parentElement.querySelector(listOfInfoElements.map(cls => `.${cls}`).join(', '))
                    });
                    showEvent(infoEvent);
                  });
                });
                node.querySelectorAll('.rotoclear-modal__close').forEach(modal => {
                  bindCloseEventListenerForModals(modal);
                });
              });
            }
          });
        }
      }
    });
    singleConfiguratorModule.querySelectorAll(listOfInfoElements.map(cls => `.${cls}`).join(', '))
      .forEach(el => bindEventListenerForModals(el));
    singleConfiguratorModule.querySelectorAll('.rotoclear-modal__close').forEach(modal => {
      bindCloseEventListenerForModals(modal);
    });
    singleConfiguratorModule.querySelectorAll('.rotoclear-modal').forEach(modal => {
      modal.addEventListener('mouseenter', (event) => {
        event.stopPropagation();
        event.preventDefault();
        const infoEvent = new MouseEvent('mouseenter', {
          bubbles: true,
          relatedTarget: event.currentTarget.parentElement.parentElement.querySelector(listOfInfoElements.map(cls => `.${cls}`).join(', '))
        });
        showEvent(infoEvent);
      });
      modal.addEventListener('mouseleave', (event) => {
        handleMouseLeave(event);
      });
    });

    observer.observe(singleConfiguratorModule, { childList: true, subtree: true });
  }
  // Timeout-Variable für verzögertes Schließen
  let closeTimeout = null;

  function closeModals(modal) {
    singleConfiguratorModule.querySelectorAll('.rotoclear-modal--open')
      .forEach(m => {
        // Only close other modals except the one we currently want to keep open
        if (m !== modal) {
          m.classList.remove('rotoclear-modal--open');
        }
      });
  }
  function bindCloseEventListenerForModals(element) {
    element.addEventListener('click', (event) => {
      closeModals();
      event.preventDefault();
      event.stopPropagation();
    });
  }
  function bindEventListenerForModals(element) {
    element.addEventListener('click', (event) => {
      // Handle the click event for the modal
      console.log('Modal clicked:', event);
      showEvent(event);
    });
    element.addEventListener('focus', (event) => {
      showEvent(event);
    });
    element.addEventListener('blur', (event) => {
      closeModals();
    });
    element.addEventListener('mouseenter', (event) => {
      showEvent(event);
    });
    element.addEventListener('mouseleave', (event) => {
      handleMouseLeave(event);
    });
  }

  function handleMouseLeave(event) {
    const related = event.relatedTarget;
    // Check if mouse is moving to an info icon oder ein Modal
    const isInfoIcon = related && listOfInfoElements.some(cls => related.classList && related.classList.contains(cls));
    const isModal = related && related.classList && related.classList.contains('rotoclear-modal');
    if (!isInfoIcon && !isModal) {
      // Verzögertes Schließen vormerken
      if (closeTimeout) clearTimeout(closeTimeout);
      console.log('Setting close timeout');
      closeTimeout = setTimeout(() => {
        closeModals();
        closeTimeout = null;
      }, 300); // 300ms Verzögerung
    }
  }

  function showEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    // Falls ein Schließ-Timeout läuft, abbrechen
    if (closeTimeout) {
      console.log('Clearing close timeout');
      clearTimeout(closeTimeout);
      closeTimeout = null;
    }
    const target = event.currentTarget ?? event.relatedTarget;
    const modal = target.parentElement.querySelector('.rotoclear-modal');
    const arrow = modal.querySelector('.rotoclear-modal__arrow');
    closeModals(modal);
    showModal(target, modal, arrow);
  }

  function showModal(anchorElement, modalElement, arrowElement) {
    modalElement.classList.add('rotoclear-modal--open');
    computePosition(anchorElement, modalElement, {
      placement: 'bottom',
      middleware: [
        offset([0, 10]),
        flip(),
        shift({ padding: 5 }),
        arrowElement ? arrow({ element: arrowElement, padding: 5 }) : null
      ]
    }).then(({ x, y, placement, middlewareData }) => {
      Object.assign(modalElement.style, {
        left: `${x}px`,
        top: `${y}px`
      });
      if (middlewareData.arrow) {
        const staticSide = {
          top: 'bottom',
          right: 'left',
          bottom: 'top',
          left: 'right'
        }[placement.split('-')[0]];
        Object.assign(arrowElement.style, {
          left: `${middlewareData.arrow.x}px`,
          top: `${middlewareData.arrow.y}px`,
          right: '',
          bottom: '',
          [staticSide]: 'calc(-0.5 * var(--arrow-size, 10px))',
        });
      }
    });
  }
});
